import React from 'react'
import fields from '../data/FieldDefinitions'
import Map from '../components/Map'

export default ({ field, data, getData, fieldDefinition, ...props }) => {
  if (!fieldDefinition) {
    fieldDefinition = fields[field]
  }

  const getPathProperties = iso => {
    const d = getData
      ? getData(iso)
      : (data.find(d => d.node.iso === iso) || {}).node
    const value = (d && fieldDefinition.values[d[field]]) || {}
    const fill = value.color || 'white'
    const children =
      (d && <title>{`${d.name}\n${value.label || ''}`}</title>) || null

    return {
      fill,
      onClick() {
        props.clickOnGemeinde && props.clickOnGemeinde(iso)
      },
      children,
    }
  }

  return <Map pathProperties={getPathProperties} {...props} />
}



// WEBPACK FOOTER //
// ./src/container/Atlas.js